/* ═══════════════════════════════════════════════════════════════
   إصلاح: السلة تبدو فارغة بعد الضغط على زر الرجوع (bfcache)
   ───────────────────────────────────────────────────────────────
   المشكلة:
   عدّاد السلة ومحتويات الدرج تُطبع من Liquid وقت تحميل الصفحة.
   عند الضغط على "رجوع" يعيد المتصفح الصفحة من ذاكرته (bfcache) بدل
   تحميلها من جديد، فتظهر الحالة القديمة وكأن المنتجات اختفت.
   السلة نفسها سليمة على السيرفر — المشكلة عرض فقط.

   الحل:
   عند استعادة الصفحة نقرأ /cart.js ونقارن العدد الحقيقي بالمطبوع.
   لو مختلف نعيد بناء قسمَي cart-count و cart-drawer عبر
   Section Rendering API ونستبدلهما في مكانهما — بدون إعادة تحميل.
   لو متطابق لا يحدث أي شيء: لا طلبات زائدة ولا وميض.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var COUNT_TAG = 'm-cart-count';
  var DRAWER_PARTS = [
    'MinimogCartDrawerHeader',
    'MinimogCartDrawerBody',
    'MinimogCartDrawerFooter'
  ];
  var RELOAD_GUARD_KEY = 'nr:cart-resync-reloaded-at';
  var RELOAD_GUARD_MS = 15000;

  /* الرابط الصحيح لـ cart.js مع مراعاة بادئة اللغة (/ar، /en ...) */
  function cartJsUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'cart.js';
  }

  function sectionsUrl() {
    var url = new URL(window.location.href);
    url.searchParams.set('sections', 'cart-count,cart-drawer');
    return url.toString();
  }

  /* العدد المطبوع حاليًا في الصفحة. القالب يطبع "99+" لأي رقم >= 100 */
  function readShownCount() {
    var el = document.querySelector(COUNT_TAG);
    if (!el) return null;
    var txt = (el.textContent || '').trim();
    if (txt === '') return 0;
    if (txt.indexOf('99+') === 0) return 100;
    var n = parseInt(txt, 10);
    return isNaN(n) ? null : n;
  }

  /* إعادة تحميل احتياطية، مرة واحدة فقط كل 15 ثانية (منع أي لوب) */
  function reloadOnce() {
    try {
      var last = parseInt(sessionStorage.getItem(RELOAD_GUARD_KEY) || '0', 10);
      if (Date.now() - last < RELOAD_GUARD_MS) return;
      sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
    } catch (e) {}
    window.location.reload();
  }

  function applyCartCount(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(COUNT_TAG);
    if (!fresh) return false;

    var text = (fresh.textContent || '').trim();
    var hidden = fresh.classList.contains('m:hidden');
    var nodes = document.querySelectorAll(COUNT_TAG);

    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = text;
      if (hidden) nodes[i].classList.add('m:hidden');
      else nodes[i].classList.remove('m:hidden');
    }
    return nodes.length > 0;
  }

  /* نستبدل محتوى الأجزاء الداخلية فقط، ونُبقي عنصر m-cart-drawer نفسه
     حتى لا تضيع مستمعات فتح/غلق الدرج. العناصر المخصّصة بالداخل
     تُفعَّل تلقائيًا عند إدراجها. */
  function applyCartDrawer(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var replaced = false;

    for (var i = 0; i < DRAWER_PARTS.length; i++) {
      var fresh = doc.getElementById(DRAWER_PARTS[i]);
      var current = document.getElementById(DRAWER_PARTS[i]);
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        replaced = true;
      }
    }
    return replaced;
  }

  function refreshFromServer() {
    /* صفحة السلة تُبنى من قسم مختلف — إعادة التحميل أضمن وأبسط هناك */
    if (document.body && document.body.classList.contains('template-cart')) {
      reloadOnce();
      return;
    }

    fetch(sectionsUrl(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('sections request failed');
        return res.json();
      })
      .then(function (sections) {
        var ok = false;
        if (sections && sections['cart-count']) {
          ok = applyCartCount(sections['cart-count']) || ok;
        }
        if (sections && sections['cart-drawer']) {
          ok = applyCartDrawer(sections['cart-drawer']) || ok;
        }
        if (!ok) {
          reloadOnce();
          return;
        }
        document.dispatchEvent(new CustomEvent('nr:cart-resynced'));
      })
      .catch(function () {
        reloadOnce();
      });
  }

  function resync() {
    var shown = readShownCount();
    if (shown === null) return; /* لا يوجد عدّاد سلة في هذه الصفحة */

    fetch(cartJsUrl(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        if (shown === cart.item_count) return;
        if (shown === 100 && cart.item_count >= 100) return; /* كلاهما "99+" */
        refreshFromServer();
      })
      .catch(function () {});
  }

  /* رجوع/تقدّم بدون bfcache: الصفحة تأتي من كاش HTTP وتكون قديمة أيضًا */
  function restoredFromHistory() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'back_forward') return true;
    } catch (e) {}
    try {
      if (performance.navigation && performance.navigation.type === 2) return true;
    } catch (e) {}
    return false;
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted || restoredFromHistory()) resync();
  });
})();
